import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";


export const sendBannerRequestThunk = createAsyncThunk(
  "banner/sendRequest",
   async (_, { rejectWithValue }) => {
    try {
      const response = await api.post("api/advt/banner-request");
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }  
  }  
);

export const fetchBannerRequestDetail = createAsyncThunk(
  "banner/fetchDetail",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("api/advt/banner-request-detail");
      return response.data.data; // this contains the object or null
    } catch (err) {
      // If no request found → show form
      if (err.response?.status === 404) return null;
      return rejectWithValue(err.response?.data || "Failed to fetch banner request");
    }
  }
);

const bannerRequestSlice = createSlice({
  name: "banner",
  initialState: {
    loading: false,
    success: false,
    error: null,
     requestDetail: null,
  },
  reducers: {
    resetBannerRequest(state) {
      state.success = false;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendBannerRequestThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendBannerRequestThunk.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(sendBannerRequestThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });

      builder
  .addCase(fetchBannerRequestDetail.fulfilled, (state, action) => {
    state.requestDetail = action.payload;
    
    // If detail exists → show success screen
    state.success = action.payload ? true : false;
  });
  },
});

export const { resetBannerRequest } = bannerRequestSlice.actions;
export default bannerRequestSlice.reducer;
